import React from 'react';
import ArticlesListSection from '../components/molecules/articlesListSection/articlesListSection';
import TabProducts from '../shared/components/molecules/tabProducts/tabProducts';
import Layout from '../shared/components/organisms/layout/layout';
import SEO from '../shared/components/seo';
import useBrowserMode from '../shared/hooks/useBrowserMode';
import useMobileMode from '../shared/hooks/useMobileMode';

const HomeSeccionArticulos = props => {

  const { isMobile, currentPage } = useMobileMode();
  const { isBrowser } = useBrowserMode();
  const articleRef = React.useRef();

  let _parentNode = isBrowser ? document.querySelector('body') : null;
  const parentNode = _parentNode;

  // const dataFiltered = props.data.allContentfulTenaSeccionArticulos.nodes.filter(node => node.slug === props.pageContext.slug)[0];
  const dataFiltered = props.pageContext;
  
  React.useEffect(() => {
    if (parentNode && parentNode.scrollTop > 0) {
      parentNode.scroll({
        top: 0,
        behavior: 'smooth',
      })
    }
  });
  
  return (
    <Layout isMobile={isMobile} currentPage={currentPage}>
      <SEO
        title={props.pageContext.metaTitulo}
        description={props.pageContext.metaDescripcion.metaDescripcion}
        lang={props.pageContext.language}
      />
      <article ref={articleRef}>
        <TabProducts slug={props.pageContext.slug} tabs={props.pageContext.menu} />
        <ArticlesListSection pauta={dataFiltered.pautas} tienePautas={dataFiltered.tienePautas} isCurved={true} isMobile={isMobile} leafletContent={dataFiltered.queryRegister.nodes[0]}  articulos={dataFiltered.articulos} tags={dataFiltered.etiquetas} currentSlug={dataFiltered.slug} />
      </article>
    </Layout>
  )
}

export default HomeSeccionArticulos;